import { SHOW_MODAL_ERROR } from "core-web/state/models/Modal/constants";
import store from "core-web/state/store";

const showModalError = () => (dispatch) => {
    dispatch({
        type: SHOW_MODAL_ERROR,
    });
};

export default () => store.dispatch(showModalError());
